var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66613 11.3335L1.66602 9.66687H15.1426L11.8512 6.37541L13.0297 5.1969L18.333 10.5002L13.0297 15.8035L11.8512 14.625L15.1427 11.3335L1.66613 11.3335Z",
    fill: "#2B303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToRight);
export default __webpack_public_path__ + "static/media/toRight.0a78d8c366dd32970fa91e7b0efc31ae.svg";
export { ForwardRef as ReactComponent };